import { FunctionComponent } from 'react';

import { MplButton } from '../../atoms/MplButton/MplButton';
import { ArrowRightIcon } from '../../icons/ArrowRight';

import { Root } from './CrashMessage.styles';

interface ICrash {
	onCLick?: (r: string) => void;
}

export const CrashMessage: FunctionComponent<ICrash> = ({ onCLick }) => {
	return (
		<Root>
			<h1>Something went wrong</h1>
			<MplButton
				fullWidth
				onClick={() => onCLick && onCLick('/home')}
				endIcon={<ArrowRightIcon />}
			>
				I'm good
			</MplButton>
		</Root>
	);
};

export default CrashMessage;
